import React from 'react';
import SvgIcon from 'e100-react-components/lib/components/SvgIcon';
import { IProps } from 'e100-react-components/lib/components/SvgIcon/index';

export const Refresh = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M12 3C16.97 3 21 7.03 21 12C21 16.97 16.97 21 12 21C9.51 21 7.26965 19.9904 5.63965 18.3604L7.05957 16.9404C8.31957 18.2104 10.07 19 12 19C15.87 19 19 15.87 19 12C19 8.13 15.87 5 12 5C8.13 5 5 8.13 5 12H8L3.95996 16.0303L3.88965 15.8896L0 12H3C3 7.03 7.03 3 12 3Z"/>
  </SvgIcon>
);
